// Shared styling for auth form components
export const textFieldStyle = {
    '& .MuiOutlinedInput-root': {
        borderRadius: 0,
        '& fieldset': {
            borderColor: 'black',
            borderWidth: '1px',
        },
        '&:hover fieldset': {
            borderColor: 'black',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'black',
            borderWidth: '1px',
        },
        '&.Mui-error fieldset': {
            borderColor: '#ff2c2c',
            borderWidth: '1px',
        },
    },
};

